import React, { useState, useEffect, useMemo, useCallback, useContext } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { i18nValue, formatTimeFromLanguage } from '../functions';
import { NavLink, useNavigate } from 'react-router-dom';
import Screen from '../components/Screen';
import { getCDNImage } from '../globals';
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { useParams } from 'react-router';
import { T } from 'react-translator-component';
import useBookable from "../hooks/useBookable";
import DateSelectorModal from "../components/UpSelling/DateSelectorModal";
import processHtml from "../components/processHtml";
import PublicBookableWizard from "../components/PublicBookableWizard";


const PublicBookableDetail = () => {
  const { id, redirect } = useParams();
  const navigate = useNavigate();
  const { data: hotel, sectionsByCode } = useContext(HotelContext)
  const { language, RoomOccupation, requestCreate } = useContext(UserContext)
  const [data, setData] = useState(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const { getBookableItem } = useBookable();
  const [showDateSelector, setShowDateSelector] = useState(true);

  const [scrollToBottom, setScrollToBottom] = useState(0);
  const [backTo, setBackTo] = useState(null);

  useEffect(() => {
    getBookableItem(id).then(r => setData(r))
  }, [id])

  useEffect(() => {
    if (redirect) {
      setBackTo(redirect.replace("__", "/", redirect));
    } else {
      // Si no hay redirect, usar el historial
      setBackTo(null);
    }
  }, [redirect])

  // useEffect(() => {
  //   // getBookableItem(id).then(r => setData(r))

  //   setData({
  //     "id": "45b3aa80-a54d-488d-a9c7-49114a6756e7",
  //     "hotelId": "511e8df9-672d-42b1-9711-d82beb7baf64",
  //     "name": "EN - LOVE BEACH CLUB",
  //     "nameI18n": {
  //       "de": "DE - Nombre",
  //       "en-US": "EN - LOVE BEACH CLUB",
  //       "it": "IT - Nombre",
  //       "fr": "FR - Nombre"
  //     },
  //     "description": "<u>Love Beach Club</u> is a fresh take on boho chic and trendy cuisine, blending the freshest ingredients found on our Mexican coasts from Baja California to Quintana Roo. Stop by for a mouthwatering organic tiki cocktail!",
  //     "descriptionI18n": {
  //       "de": "",
  //       "en-US": "<u>Love Beach Club</u> is a fresh take on boho chic and trendy cuisine, blending the freshest ingredients found on our Mexican coasts from Baja California to Quintana Roo. Stop by for a mouthwatering organic tiki cocktail!",
  //       "it": "",
  //       "fr": ""
  //     },
  //     "photo": "511e8df9-672d-42b1-9711-d82beb7baf64/restaurant_main_1698748612946.jpg",
  //     "gallery": [
  //       "511e8df9-672d-42b1-9711-d82beb7baf64/restaurant_gallery1698748640689_0.jpg"
  //     ],
  //     "visible": true,
  //     "horary": "",
  //     "horaryI18n": {
  //       "de": "",
  //       "en-US": "",
  //       "it": "",
  //       "fr": ""
  //     },
  //     "menus": []
  //   })

  // }, [id])

  const onBook = useCallback((day, hour, qty, allDay = false, multiplyPrice = false) => {
    setSending(true);

    setTimeout(() => {
      setSending(false);
      setSent(true);
    }, 1000);

    const cart = {
      qty: qty,
      total: data.price * qty,
      items: [{
        itemId: id,
        type: 'services_booking',
        qty: qty,
        price: data.price,
        vat: data.vat,
        account: data.account,
        subAccount: data.subAccount,
        total: data.price * qty
      }]
    }

    const payload = {
      hotelId: hotel.id,
      roomOccupationId: RoomOccupation.id,
      type: 'services_booking',
      data: JSON.stringify({
        service: {
          id: id,
          name: data.name
        },
        day: day,
        hour: hour,
        qty: qty
      }),
      cart: JSON.stringify(cart)
    }

    requestCreate(payload).then(() => {
    })
      .catch((response) => {
        console.log('error', response)
      });


  }, [data]);

  const handleRefreshScrollToBottom = () => {
    setScrollToBottom(scrollToBottom + 1);
  }


  const handleAddToCart = (day, hour, qty, allDay = false, multiplyPrice = false) => {
    onBook(day, hour, qty, allDay, multiplyPrice);
  }


  if (!data) {
    return (
      <div
        className="loading d-flex justify-content-center align-items-center"
        style={{ height: "100vh", width: "100vw" }}
      >
        <div className="spinner-border" role="status"></div>
      </div>
    );
  }


  const handleBackClick = () => {
    if (!backTo) {
      navigate(-1);
      return true;
    }
    return false;
  }

  return (
    <Screen
      section="service-booking"
      title={i18nValue(sectionsByCode["service_services_booking"], "title", language)}
      backUrl={backTo ? `./${backTo}` : null}
      onBackClick={handleBackClick}
      autoScrollToBottom={scrollToBottom}
    >
      <h5 className="page-detail-title mb-0 mt-1">{i18nValue(data, 'name', language)}</h5>
      <p className="mb-3 font-sm">{T('general.from')} {formatTimeFromLanguage(data.startHour, language)} {T('general.to')} {formatTimeFromLanguage(data.endHour, language)} / {T('general.duration')}: {data.durationToShow} {T('general.min')}</p>
      {data.photo && <img src={getCDNImage(data.photo)} className="page-detail-photo w-100 mb-3" />}
      {!data.photo && <img src={'/logo_57.png'} className="page-detail-photo no-photo w-100 mb-3" />}
      <p className="page-detail-description text-with-break-line">{processHtml(i18nValue(data, 'description', language))}</p>
      <div className="footer-container shadow-lg">
        {sending && <div className="loading text-center mt-5"><div className="spinner-border" role="status"></div></div>}
        {!sending && sent &&
          <Container><Row><Col className="text-center mt-5">
            <div className="text-center mt-5" style={{ background: "white", border: "1px solid #EEE", borderRadius: 10, padding: "10px 20px" }}>
              <span className="font-size-sm d-block mb-3"><FontAwesomeIcon icon={faThumbsUp} style={{ fontSize: 80, color: '#3699ff', marginTop: -20 }} className="mb-1" /></span>
              <p style={{ fontSize: "0.9rem" }} className="mb-0">
                {T('services.sent-text')}<br /><NavLink className="btn btn-primary mt-4 mb-2 text-white" style={{ color: 'black' }} to={{ pathname: '/' + hotel.code + '/checkin/status' }} replace>{T('services.go-to-requests')}</NavLink>
              </p>
            </div></Col></Row></Container>}
        {!sending && !sent && <PublicBookableWizard
          showDateSelector={showDateSelector && !sent && !sending}
          hotelId={hotel.id}
          bookableItemId={data.id}
          bookableItemName={i18nValue(data, 'name', language)}
          showCancel={false}
          handleAddToCart={handleAddToCart}
          setShowDateSelector={setShowDateSelector}
          refreshScrollToBottom={handleRefreshScrollToBottom}
        />}
      </div>
    </Screen>
  );
}

export default PublicBookableDetail;